import context from './context.js';

const createPolyfill = (lookup, fn) => () =>
  !lookup()
    ? new Promise((resolve, reject) => fn(resolve, reject))
    : Promise.resolve(lookup());

const polyfills = {
  intl: createPolyfill(
    () => context.Intl,
    done => require.ensure([], () => done(require('intl')), 'Polyfills')
  ),
  /**
   * Element.closest() Polyfill
   * For browsers that do not support Element.closest(), but carry support for document.querySelectorAll()
   * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
   */
  closest: createPolyfill(
    () => context.Element && context.Element.prototype.closest,
    done =>
      require.ensure(
        [],
        () =>
          done(
            (context.Element.prototype.closest = function(s) {
              // eslint-disable-next-line one-var
              var matches = (
                  context.document || context.ownerDocument
                ).querySelectorAll(s),
                i,
                el = this;
              do {
                i = matches.length;
                while (--i >= 0 && matches.item(i) !== el) {
                  /**/
                }
              } while (i < 0 && (el = el.parentElement));
              return el;
            })
          ),
        'Polyfills'
      )
  ),
  /**
   * EventSource Polyfill
   * https://www.w3.org/TR/eventsource/
   */
  eventsource: createPolyfill(
    () => {
      const XHR = context.XMLHttpRequest;
      const XDR = context.XDomainRequest;
      const isCORSSupported =
        XHR != undefined && new XHR().withCredentials != undefined; // eslint-disable-line eqeqeq
      const Transport =
        isCORSSupported || (XHR != undefined && XDR == undefined) ? XHR : XDR; // eslint-disable-line eqeqeq
      const isEventSourceNotSupported =
        isCORSSupported &&
        !(
          context.EventSource !== undefined &&
          'withCredentials' in context.EventSource.prototype
        );

      return (
        Transport !== undefined &&
        (context.EventSource === undefined || isEventSourceNotSupported)
      );
    },
    done => {
      require.ensure(
        [],
        () => done(require('event-source-polyfill')),
        'Polyfills'
      );
    }
  ),
  /**
   * CustomEvent() Polyfill
   * For browsers that do not support CustomEvent() constructor functionality
   * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
   */
  customevent: createPolyfill(
    () => typeof context.CustomEvent === 'function',
    done =>
      require.ensure(
        [],
        () => done(require('custom-event-polyfill')),
        'Polyfills'
      )
  ),
  /**
   * User Timing API Polyfill
   * https://www.w3.org/TR/user-timing/
   */
  usertiming: createPolyfill(
    () => !(typeof context.performance === 'undefined'),
    done => require.ensure([], () => done(require('usertiming')), 'Polyfills')
  ),
  /**
   * window.fetch polyfill
   * https://github.com/github/fetch
   */
  fetch: createPolyfill(
    () => context.fetch,
    done => require.ensure([], () => done(require('whatwg-fetch')), 'Polyfills')
  )
};

export default function load() {
  const keys = Object.keys(polyfills);
  return Promise.all(keys.map(k => polyfills[k]())).then(results =>
    keys.reduce(
      (o, k, i) => ({
        ...o,
        [k]: results[i]
      }),
      {}
    )
  );
}



// WEBPACK FOOTER //
// ./js/util/polyfills.js